module.exports = __webpack_public_path__ + "static/media/education-object-2-0.6afdcc1f.png";